/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react'
import { AiFillEdit } from 'react-icons/ai'
import { BsFilePdf } from 'react-icons/bs'
import { Icon, Modal, Checkbox, Input, Divider } from 'antd'
import { connect } from 'react-redux'
import cuid from 'cuid'
import Autocomplete from 'react-autocomplete'
import get from 'lodash.get'

import Card from '../../../../components/Card'
import SvgIcon from '../../../../components/SvgIcon'
import { VehicleBindAlerts } from '../../../../components/Antt/VehicleBindAlerts'
import { getEditVehiclePath } from '../../../../components/Antt/utils'
import { VEHICLE_TYPE } from '../../../../utils/fleetFormatter'
import { trackingDeviceTechnology } from '../../../NewFleet/utils'
import {
  handleTrackingDeviceFields,
  handleUpdateVehicle,
  handleWithMissingTracker,
  onTrackingDeviceFields,
} from '../../actions'

import css from './index.scss'

const { TextArea } = Input
const validations = {
  trackingDeviceId: false,
  trackingDeviceTechnology: false,
  textareaContent: false,
}
class VehicleToBindCard extends Component {
  state = {
    validation: validations,
    addTrackingInformation: true,
    textareaContent: '',
    openTrackerModal: false,
    trackingDeviceTechnology: '',
    trackingDeviceId: '',
  }

  componentDidMount() {
    if (this.props.vehicle) {
      if (this.props.primaryKey === 'primaryVehicle') {
        this.props.handleTrackingDeviceFields(this.props.vehicle, this.props.primaryKey)
      }
      this.setState({
        trackingDeviceTechnology: this.props.vehicle.trackingDeviceTechnology
          ? this.props.vehicle.trackingDeviceTechnology
          : '',
        trackingDeviceId: this.props.vehicle.trackingDeviceId
          ? this.props.vehicle.trackingDeviceId
          : '',
      })
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.vehicle) {
      if (
        nextProps.vehicle.trackingDeviceId &&
        nextProps.vehicle.trackingDeviceId !== this.state.trackingDeviceId
      ) {
        this.setState({
          trackingDeviceTechnology: nextProps.vehicle.trackingDeviceTechnology,
          trackingDeviceId: nextProps.vehicle.trackingDeviceId,
        })
      }
      if (!nextProps.vehicle.trackingDeviceId) {
        this.setState({
          trackingDeviceTechnology: '',
          trackingDeviceId: '',
        })
      }
      if (
        !this.props.mappedTrackingDeviceFields[nextProps.vehicle.id] &&
        this.props.primaryKey === 'primaryVehicle'
      ) {
        this.props.handleTrackingDeviceFields(nextProps.vehicle, nextProps.primaryKey)
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.primaryKey === 'primaryVehicle' && !prevProps.isOpen && this.props.isOpen) {
      this.setState({ openTrackerModal: true })
    }
    if (this.props.primaryKey === 'primaryVehicle' && prevProps.isOpen && !this.props.isOpen) {
      this.setState({ openTrackerModal: false })
    }
    if (prevState.openTrackerModal === true && this.state.openTrackerModal === false) {
      this.setState({
        addTrackingInformation: true,
        textareaContent: '',
        validation: validations,
      })
    }
  }

  handleTrackingDeviceTechnology = (value) => {
    const newObject = {
      trackingDeviceTechnology: value,
    }
    this.setState(newObject)
  }
  handleTextareaContent = (evt) => {
    const newObject = {
      textareaContent: evt.target.value,
    }
    this.setState(newObject)
  }
  handleAutocompleteInput = (e) => {
    const newObject = {
      trackingDeviceTechnology: e.target.value,
    }
    this.setState(newObject)
  }
  handleTrackingDeviceId = (e) => {
    const newObject = {
      trackingDeviceId: e.target.value,
    }
    this.setState(newObject)
  }

  onCloseTrackerModal = () => {
    if (this.props.isOpen) {
      this.props.handleIsOpen(false)
      return
    }

    this.setState({ openTrackerModal: false, validation: validations })
  }

  handleOpenTrackerModal = () => {
    this.setState({
      openTrackerModal: true,
    })
  }

  handleSubmit(vehicle, editedVehicle, data) {
    const { hashId, deliveryId } = this.props.load
    if (this.state.addTrackingInformation) {
      if (
        !this.state.trackingDeviceId ||
        this.state.trackingDeviceId.length < 3 ||
        !this.state.trackingDeviceTechnology ||
        this.state.trackingDeviceTechnology.length < 3
      ) {
        this.setState({
          validation: {
            trackingDeviceId: !!(
              !this.state.trackingDeviceId || this.state.trackingDeviceId.length < 3
            ),
            trackingDeviceTechnology: !this.state.trackingDeviceTechnology,
          },
        })
      }
      if (
        !this.state.trackingDeviceId ||
        this.state.trackingDeviceId.length < 3 ||
        !this.state.trackingDeviceTechnology
      ) {
        return
      }
      this.props.onTrackingDeviceFields(vehicle.id, this.state.addTrackingInformation, 'added')
      this.props.updateVehicle({
        id: vehicle.id,
        data: editedVehicle,
        plate: data.plate,
        toBind: this.props.toBind,
        hashId,
        deliveryId,
      })
    } else {
      if (!this.state.addTrackingInformation && this.state.textareaContent.length < 5) {
        this.setState({
          validation: {
            ...this.state.validation,
            textareaContent: true,
          },
        })
        return
      }
      this.props.onTrackingDeviceFields(
        vehicle.id,
        this.state.addTrackingInformation,
        this.state.textareaContent,
      )
      this.props.handleWithMissingTracker(
        hashId,
        {
          deliveryId,
          type: 'TRACKING_NOT_PROVIDED',
          value: this.state.textareaContent,
        },
        this.props.toBind,
      )
    }

    this.onCloseTrackerModal()
  }

  renderAutocompleteInput = () => (
    <Autocomplete
      getItemValue={(item) => item.label}
      items={trackingDeviceTechnology.map((item) => ({
        id: item,
        label: item,
      }))}
      shouldItemRender={(item, value) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1}
      onChange={(e) => this.handleAutocompleteInput(e)}
      onSelect={(v) => this.handleTrackingDeviceTechnology(v)}
      wrapperProps={{
        style: {
          width: '450px',
          height: '35px',
        },
      }}
      renderItem={(item, highlighted) => (
        <div
          key={cuid()}
          style={{
            backgroundColor: highlighted ? '#bb22fb' : '#fff',
          }}
          className={css.options}
        >
          {item.label}
        </div>
      )}
      inputProps={{
        className: css.input,
        placeholder: 'Tecnologia do rastreador?',
      }}
      menuStyle={{
        padding: 6,
        borderRadius: '3px',
        backgroundColor: '#fff',
        overflow: 'auto',
        maxHeight: '200px',
        zIndex: 999,
        position: 'fixed',
        paddingLeft: 8,
      }}
      value={this.state.trackingDeviceTechnology}
    />
  )
  renderValidations = (field) => (
    <span
      style={{
        color: 'red',
        fontSize: 12,
        display: 'block',
        marginTop: 4,
      }}
    >
      O campo {field} é requerido.
    </span>
  )

  renderTrackerSettings = () => {
    const { vehicle, data } = this.props
    const { validation } = this.state
    const editedVehicle = {
      ...vehicle,
      flTrackingDevice: true,
      trackingDeviceTechnology: this.state.trackingDeviceTechnology,
      trackingDeviceId: this.state.trackingDeviceId,
    }

    return (
      <div className={css.trackerContainer}>
        <button className={css.trackerButton} onClick={this.handleOpenTrackerModal}>
          {vehicle.flTrackingDevice ? 'Editar rastreador' : 'Adicionar rastreador'}
          <AiFillEdit
            size={14}
            color="white"
            style={{
              marginLeft: 5,
            }}
          />
        </button>
        {vehicle.flTrackingDevice && (
          <div className={css.trackerTypeBox}>
            <span>Tecnologia do rastreador:</span>
            <p>{vehicle.trackingDeviceTechnology}</p>
          </div>
        )}
        <Modal
          footer={null}
          visible={this.state.openTrackerModal}
          title={vehicle.flTrackingDevice ? 'Editar Rastreador' : 'Adicionar Rastreador'}
          onCancel={this.onCloseTrackerModal}
          zIndex={this.props.isPendingResolution ? 1002 : 1000}
        >
          <div className={css.contentBox}>
            <div className={css.inputBox}>
              <Checkbox
                value={this.state.addTrackingInformation}
                checked={!this.state.addTrackingInformation}
                onChange={(evt) => this.setState({ addTrackingInformation: !evt.target.value })}
              >
                Não adicionar informações do rastreador
              </Checkbox>
            </div>
            {this.state.addTrackingInformation ? (
              <React.Fragment>
                <div className={css.inputBox}>
                  <label>Tecnologia</label>
                  {this.renderAutocompleteInput()}
                  {validation.trackingDeviceTechnology &&
                    this.renderValidations('Tecnologia do Rastreador')}
                </div>
                <div className={css.inputBox}>
                  <label
                    style={{
                      display: 'block',
                    }}
                  >
                    Id
                  </label>
                  <input
                    value={this.state.trackingDeviceId}
                    className={css.input}
                    onChange={this.handleTrackingDeviceId}
                    placeholder="Id do rastreador?"
                  />
                  {validation.trackingDeviceId && this.renderValidations('Id do Rastreador')}
                </div>
                <Divider />
                <div
                  className={css.contentBox}
                  style={{
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    gap: 30,
                    alignItems: 'center',
                    marginTop: 10,
                  }}
                >
                  <div className={css.alertWrapper}>
                    <p
                      style={{
                        margin: 0,
                        fontSize: 16,
                        width: 460,
                      }}
                    >
                      Para iniciar o rastreamento, acesse o portal de seu rastreador e realize o
                      espelhamento. Segue abaixo um guia de espelhamento para cada tecnologia:
                    </p>
                    <ul style={{ padding: 0, color: '#7206a9' }}>
                      <li className={css.li}>
                        <a
                          href="https://storage.googleapis.com/prd-azship-storage-public/general/PROCESSO%20DE%20ESPELHAMENTO%20POR%20TECNOLOGIA.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ display: 'contents' }}
                        >
                          <div className={css.ellipse} />
                          <BsFilePdf size={16} />
                          <span>Processo de espelhamento por tecnologia.</span>
                        </a>
                      </li>
                      <li className={css.li}>
                        <a
                          href="https://storage.googleapis.com/prd-azship-storage-public/general/Ficha%20de%20Ativa%C3%A7%C3%A3o%20Omnilink%20DAJ8E02.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ display: 'contents' }}
                        >
                          <div className={css.ellipse} />
                          <BsFilePdf size={16} />
                          <span>Ficha de Ativação omnlink.</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <div className={css.inputBox}>
                <label>Justifique</label>
                <TextArea
                  rows={5}
                  value={this.state.textareaContent}
                  onChange={this.handleTextareaContent}
                />
                {validation.textareaContent && this.renderValidations('Justifique')}
              </div>
            )}

            <div className={css.buttonsBox}>
              <button className={css.buttonDefault} onClick={this.onCloseTrackerModal}>
                Cancelar
              </button>
              <button
                className={css.buttonDefault}
                style={{
                  backgroundColor: '#7906a9',
                  color: '#fff',
                }}
                onClick={() => this.handleSubmit(vehicle, editedVehicle, data)}
              >
                Salvar
              </button>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
  renderTruckType = () => {
    const { vehicle } = this.props
    if (vehicle.type === 'SIMPLE_TRACTOR') {
      return 'truck.svg'
    } else if (vehicle.type === 'TRAILER') {
      return 'trailer.svg'
    }
    return 'truck full.svg'
  }

  render() {
    const { vehicle, data, trackerOnly } = this.props

    const { flEnableTrackingDevice } = this.props.load
    const linkedVehicleInfo = get(this.props, 'data.infoShippingLinkedDriverOrVehicle', null)
    const editVehiclePath = getEditVehiclePath(data)

    if (vehicle) {
      if (trackerOnly) {
        if (!flEnableTrackingDevice) return null
        return this.renderTrackerSettings()
      }

      return (
        <Card
          className={css.container}
          style={{ margin: 8, marginLeft: 0, marginTop: 0, width: '100%' }}
        >
          {vehicle.type !== 'TRAILER' ? (
            <div
              className={css.closeBtn}
              tabIndex={0}
              role="button"
              onClick={this.props.onCloseClick}
            >
              <Icon type="close" />
            </div>
          ) : null}
          <div className={css.row} style={{ alignItems: 'center' }}>
            <div className={css.truckAvatarContainer}>
              <SvgIcon
                path={`/assets/icons/${this.renderTruckType()}`}
                svgClassName={css.truckAvatar}
              />
            </div>
            <div
              className={css.column}
              style={{ marginLeft: 24, flex: 1, alignItems: 'flex-start' }}
            >
              <span className={css.displayName} style={{ fontSize: 18 }}>
                {VEHICLE_TYPE[vehicle.type] || vehicle.type}
              </span>
              <span className={css.data} style={{ marginTop: 6 }}>
                {vehicle.plate}
              </span>
              <span className={css.data} style={{ marginTop: 6 }}>
                {vehicle.model}
              </span>
            </div>
            <div className={css.column} style={{ marginLeft: 16, flex: 1 }}>
              <span className={css.label}>Origem placa:</span>
              <span className={css.data}>
                {vehicle.city} - {vehicle.state}
              </span>
              <span className={css.label}>Ano/Modelo:</span>
              <span className={css.data}>
                {vehicle.fabricationYear}/{vehicle.modelYear}
              </span>
            </div>
          </div>
          {flEnableTrackingDevice && this.renderTrackerSettings()}
          <VehicleBindAlerts
            vehicle={vehicle}
            isPrimary={this.props.primaryKey === 'primaryVehicle'}
            flEnableCheckRntrc={this.props.flEnableCheckRntrc}
            linkedVehicleInfo={linkedVehicleInfo}
            editVehiclePath={editVehiclePath}
          />
        </Card>
      )
    }
    return null
  }
}
const mapActionsToProps = (dispatch) => ({
  updateVehicle(payload) {
    dispatch(handleUpdateVehicle(payload))
  },
  handleWithMissingTracker(id, payload, toBind) {
    dispatch(handleWithMissingTracker(id, payload, toBind))
  },
  handleTrackingDeviceFields(value, primary) {
    dispatch(handleTrackingDeviceFields(value, primary))
  },
  onTrackingDeviceFields(id, addTrackingInformation, justify) {
    dispatch(onTrackingDeviceFields(id, addTrackingInformation, justify))
  },
})
const mapStateToProps = (state) => ({
  mappedTrackingDeviceFields: state.loadsDetails.mappedTrackingDeviceFields || null,
  fl: state.loadsDetails,
})
export default connect(mapStateToProps, mapActionsToProps)(VehicleToBindCard)
